import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

// FAQ_LIST
export const getFAQList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      apiendpoints.MANAGE_GET_ALL_FAQ
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// FAQ_BY_ID
export const getFAQById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_GET_BY_ID_FAQ}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// FAQ_UPDATE
export const updateFAQ = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.MANAGE_ADD_UPDATE_FAQ,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};



// FAQ_Delete
export const DeleteFAQDocument = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_FAQ_DELETE}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


//Local Storage
export const setFaqId = (id) => {
  localStorage.setItem("contractId", id);
};

export const getFaqId = () => {
  const id = localStorage.getItem("contractId");
  if (id !== null && id !== undefined) {
    return id;
  } else {
    return null;
  }
};
export const removeFaqId = () => {
  localStorage.removeItem("contractId");
};
